/**
 * @desc 根据ucenter用户编号获取详情
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(userNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/getStaffInfoByUserNo/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
